module.exports = __webpack_public_path__ + "../resources/images/illustration_inbox-a9877224abfc91ba1403b8c8ac8941ba.svg";